//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.EnumType
import kotlin.Array
import kotlin.Deprecated
import kotlin.String
import kotlin.collections.List

public enum class InspectionStatus(
  public val rawValue: String,
) {
  IN_PROGRESS("IN_PROGRESS"),
  COMPLETED("COMPLETED"),
  APPROVED("APPROVED"),
  /**
   * Auto generated constant for unknown enum values
   */
  UNKNOWN__("UNKNOWN__"),
  ;

  public companion object {
    public val type: EnumType =
        EnumType("InspectionStatus", listOf("IN_PROGRESS", "COMPLETED", "APPROVED"))

    /**
     * All [InspectionStatus] known at compile time
     */
    public val knownEntries: List<InspectionStatus>
      get() = listOf(
        InspectionStatus.IN_PROGRESS,
        InspectionStatus.COMPLETED,
        InspectionStatus.APPROVED)

    /**
     * Returns all [InspectionStatus] known at compile time
     */
    @Deprecated(
      message = "Use knownEntries instead",
      replaceWith = ReplaceWith("this.knownEntries"),
    )
    public fun knownValues(): Array<InspectionStatus> = knownEntries.toTypedArray()

    /**
     * Returns the [InspectionStatus] that represents the specified [rawValue].
     * Note: unknown values of [rawValue] will return [UNKNOWN__]. You may want to update your schema instead of calling this function directly.
     */
    public fun safeValueOf(rawValue: String): InspectionStatus = entries.find { it.rawValue == rawValue } ?: UNKNOWN__
  }
}
